module.exports = __webpack_public_path__ + "img/HZ-B5046.53e92c99.jpg";